import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  AdPerformanceResponse,
  FinancialPeriodParams
} from "../financialReport.types";
import { requestAdPerformance } from "./adPerformance.request";

const useAdPerformance = (
  params: FinancialPeriodParams,
  options?: QueryOptions<AdPerformanceResponse, ApiServiceError<ApiError>>
) => {
  return useQuery({
    queryKey: ["ad-performance", params],
    queryFn: async () => await requestAdPerformance(params),
    onError: toastServerError,
    ...options
  });
};

export default useAdPerformance;
